import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.push.js";
import { Plus, RemoveFilled } from "@element-plus/icons-vue";
import { selectImage } from "@/jsUtils/selectImage";
import { post } from "@/jsUtils/nodejsRequest";
import { blobToBase64 } from "@/jsUtils/fileConvert";
import { ElMessage } from "element-plus";
import { default_max_width } from "@/globalcfg.js";
export default {
  components: {
    Plus,
    RemoveFilled
  },
  data() {
    return {
      loading: false,
      //反馈地址
      feedbackUrl: "/checkhost/feedback",
      //表单数据
      feedbackForm: {
        desc: "",
        phoneInfo: "",
        contact: ""
      },
      //验证规则
      rules: {
        desc: [{
          required: true,
          message: "content can not be null",
          trigger: "blur"
        }],
        contact: [{
          required: true,
          message: "content can not be null",
          trigger: "blur"
        }]
      },
      //图片显示列表
      imgs: []
    };
  },
  mounted() {
    this.appName = this.$route.query.appName;
  },
  computed: {
    elformSize() {
      if (window.innerWidth >= default_max_width - 100) {
        // "min(max(7vw, 7vh), window.innerWidth * 0.07)";
        // let size = Math.min(Math.max(0.07 * window.innerWidth, 0.07 * window.innerHeight), default_max_width * 0.07);

        return "large";
      } else {
        // "min(max(5vw, 5vh), default_max_width * 0.05)";
        // let size = Math.min(Math.max(0.05 * window.innerWidth, 0.05 * window.innerHeight), default_max_width * 0.05);
        return "medium";
      }
    }
  },
  methods: {
    //选择图片
    handleSelectImg() {
      if (this.imgs.length < 5) {
        selectImage({
          maxWidth: 300,
          maxHeight: 300
        }, img => {
          let url = URL.createObjectURL(img);
          this.imgs.push({
            file: img,
            url: url
          });
        });
      } else {
        //最多上传5张
      }
    },
    //删除选择的图片
    handleDeleteImg(i) {
      this.imgs.splice(i, 1);
    },
    //提交表单
    submitForm() {
      let self = this;
      this.$refs["feedbackForm"].validate(async valid => {
        if (valid) {
          //图片数据
          let imgData = [];
          for (var i = 0; i < self.imgs.length; i++) {
            let base64 = await blobToBase64(self.imgs[i].file);
            imgData.push(base64);
          }
          //上传数据
          let feedbackData = {
            appName: self.appName,
            desc: self.feedbackForm.desc,
            phoneInfo: self.feedbackForm.phoneInfo,
            contact: self.feedbackForm.contact,
            imgs: imgData
          };
          //上传数据到后台
          self.loading = true;
          post(this.feedbackUrl, feedbackData).then(res => {
            ElMessage({
              message: "Submit succeed！",
              type: "success"
            });
            self.loading = false;
          }, err => {
            self.loading = false;
          });
        }
      });
    }
  }
};